import { ActionType, AppAction } from "../State/State";

export interface RegenerationFinishedPayload {
  x: number;
  y: number;
  success?: boolean;
}

export const getRegenerationFinishedActions = (
  payload: RegenerationFinishedPayload
): AppAction[] => {
  const actions: AppAction[] = [];

  if (payload.success === true) {
    actions.push({
      type: ActionType.ADD_REGENERATED_HEXAGON,
      x: payload.x,
      y: payload.y,
    });
  }

  actions.push({
    type: ActionType.REMOVE_REGENERATING_NOW_HEX,
    x: payload.x,
    y: payload.y,
  });

  return actions;
};
